import React from 'react';
import scrollToComponent from 'react-scroll-to-component';
import { Link } from 'react-router-dom';
import Container from 'components/Container';

import logoWhite from 'images/logo-white.svg';
import iconFb from 'images/icon-fb.svg';
import iconTwitter from 'images/icon-twitter.svg';
import iconIg from 'images/icon-ig.svg';
import iconYoutube from 'images/icon-youtube.svg';
import iconWechat from 'images/icon-wechat.svg';
import qrWechat from 'images/qr-wechat.jpg';
import { StyledFooter, WeChat } from './styles';

class Footer extends React.Component {
  state = {
    wechat: false,
  };
  scrollToSection = (ref) => {
    scrollToComponent(document.getElementById(ref), { offset: 0, align: 'top', duration: 500 });
  }
  toggleWeChat = () => {
    this.setState({ wechat: !this.state.wechat });
  };
  render() {
    return (
      <StyledFooter>
        <WeChat
          visible={this.state.wechat}
          onCancel={this.toggleWeChat}
          footer={null}
          width="255px"
        >
          <img src={qrWechat} alt="qr code" style={{ width: '100%' }} />
        </WeChat>
        <Container>
          <div className="row">
            <div className="col left">
              <img src={logoWhite} alt="AW Logo" className="aw-logo" />
              <span className="eu">Europe</span>
              <p className="info">8-9 July  |  FBML 10 July  |  ECML 11 July • Barcelona, Spain</p>
            </div>
            <div className="col right">
              <span className="hashtag">#AWeurope</span>
              <a href="https://www.facebook.com/affiliateworldconferences/" className="icon">
                <img src={iconFb} alt="Facebook" />
              </a>
              <a href="https://twitter.com/AWConferences" className="icon">
                <img src={iconTwitter} alt="Twitter" />
              </a>
              <a href="https://www.instagram.com/AWConferences/" className="icon">
                <img src={iconIg} alt="Instagram" />
              </a>
              <a href="https://www.youtube.com/affiliateworldconferences" className="icon">
                <img src={iconYoutube} alt="Youtube" />
              </a>
              <button onClick={this.toggleWeChat}>
                <img src={iconWechat} alt="Wechat" />
              </button>
              <button className="backtotop" onClick={() => { this.scrollToSection('banner'); }}>Back to top ↑</button>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col links">
              <a href="https://affiliateworldconferences.com/europe/terms-and-conditions/attendees">Terms and Conditions</a>
              <span className="separator"> • </span>
              <a href="https://www.iubenda.com/privacy-policy/66561594" target="blank">Privacy Policy</a>
              <span className="separator"> • </span>
              <Link to="/cookie-declaration">Cookie Declaration</Link>
              <span className="separator"> • </span>
              <p>Contact us at: <a href="mailto:info@awconf.com">info@awconf.com</a></p>
            </div>
            <div className="col">
              <p className="copyright">Affiliate World Conferences is brought to you by <a href="http://istackconferences.com">iStack Conferences Ltd</a>.</p>
            </div>
          </div>
        </Container>
      </StyledFooter>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js